import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import Modal from 'react-modal'
import { ButtonClose } from 'app/components/common/buttonClose'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

import styles from './dfModal.module.scss'

Modal.setAppElement('#__next')

const DFModal = ({ id, className = '', onClose, children, ...rest }) => {
  const modalRef = useRef()

  const onCloseForm = () => {
    enableBodyScroll(modalRef.current)
    clearAllBodyScrollLocks()
    if (typeof onClose === 'function') {
      onClose()
    }
    // For whatever reason overflow still applied to body, even after modal is closed.
    document.getElementsByTagName('body')[0]?.removeAttribute('style')
  }

  return (
    <Modal
      id={id}
      className={className}
      overlayClassName={styles.modal__overlay}
      onAfterOpen={() => disableBodyScroll(modalRef.current)}
      contentRef={(contentRef) => (modalRef.current = contentRef)}
      onRequestClose={onCloseForm}
      closeForm={onCloseForm}
      {...rest}
    >
      <ButtonClose
        className={`${styles.modal__close} ${styles.form}`}
        type="button"
        onClick={onCloseForm}
      />
      {children}
    </Modal>
  )
}

DFModal.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  colorClass: PropTypes.string, // define background color
  children: PropTypes.element,
  onClose: PropTypes.func,
}

export { DFModal }
